var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoutesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    width: 396,
    height: 406,
    viewBox: "0 0 396 406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#757575;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.63111,20.60277a60.27064,60.27064,0,0,0-85.13623.001L1,171.09911l25.87933,25.87842L177.374,46.48314a23.63022,23.63022,0,0,1,33.378-.001L350.56581,186.29565a23.63078,23.63078,0,0,1,0,33.37927L210.752,359.48852a23.6026,23.6026,0,0,1-33.37775,0l-89.2038-89.20459a2.83691,2.83691,0,0,1-.835-1.97388,1.9921,1.9921,0,0,1,.55658-1.49536c32.33045-32.33008,63.42231-45.51758,107.31727-45.51758h24.67627l-49.02167,49.022L194.75245,294.208l91.18518-91.18616-91.25586-91.25635-23.88843,23.889,49.0434,49.04334H195.20936c-53.224,0-94.30329,17.34485-133.19636,56.23743a38.35,38.35,0,0,0-11.27319,27.85315,39.234,39.234,0,0,0,11.55133,27.3739l89.20374,89.20447a60.19826,60.19826,0,0,0,85.13623,0L376.4452,245.55322a60.26957,60.26957,0,0,0,0-85.136Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutesIcon);
export default __webpack_public_path__ + "static/media/routes_icon.403b58993b42373486963cae8847d790.svg";
export { ForwardRef as ReactComponent };